const SoldOutIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5756_34827)">
        <path
          d="M14.3664 22.3957L13.8653 23.4351C13.3119 23.1136 12.6165 22.8892 12.1902 22.8892C11.8462 22.8892 11.6144 23.0163 11.6144 23.2706C11.6144 24.1754 14.3812 23.6595 14.3812 25.5514C14.3812 26.5982 13.4539 27.1516 12.2874 27.1516C11.4126 27.1516 10.5153 26.8226 9.89453 26.3142L10.4105 25.2897C10.9489 25.7608 11.7565 26.0749 12.3024 26.0749C12.7211 26.0749 12.9828 25.9179 12.9828 25.6187C12.9828 24.6915 10.216 25.2449 10.216 23.3903C10.216 22.4257 11.0461 21.8125 12.3024 21.8125C13.0577 21.8124 13.8279 22.0442 14.3664 22.3957Z"
          fill="#000000"
        />
        <path
          d="M20.6098 24.4866C20.6098 26.0122 19.3985 27.1712 17.7757 27.1712C16.1606 27.1712 14.9491 26.0196 14.9491 24.4866C14.9491 22.9612 16.1606 21.832 17.7757 21.832C19.3985 21.832 20.6098 22.9687 20.6098 24.4866ZM16.3101 24.4941C16.3101 25.3765 16.9905 26.057 17.7907 26.057C18.5983 26.057 19.2413 25.3766 19.2413 24.4941C19.2413 23.6117 18.5983 22.9462 17.7907 22.9462C16.9831 22.9462 16.3101 23.6118 16.3101 24.4941Z"
          fill="#000000"
        />
        <path
          d="M25.0515 25.9952V27.1095H21.4995V21.875H22.8305V25.9953H25.0515V25.9952Z"
          fill="#000000"
        />
        <path
          d="M28.1248 21.875C29.77 21.875 30.9066 22.9368 30.9066 24.4922C30.9066 26.0401 29.7549 27.1095 28.0725 27.1095H25.874V21.875H28.1248ZM27.205 26.0476H28.1547C28.9698 26.0476 29.553 25.4195 29.553 24.4997C29.553 23.5725 28.9399 22.9368 28.0949 22.9368H27.2051V26.0476H27.205Z"
          fill="#000000"
        />
        <path
          d="M29.5683 13.7276C29.303 13.7276 29.0487 13.6223 28.8611 13.4347L21.1336 5.70711C20.7431 5.31659 20.1099 5.31658 19.7194 5.70711L11.9917 13.4347C11.8042 13.6223 11.5499 13.7276 11.2846 13.7276H1.5C0.947715 13.7276 0.5 14.1754 0.5 14.7276V34C0.5 34.5523 0.947715 35 1.5 35H39.353C39.9053 35 40.353 34.5523 40.353 34V14.7276C40.353 14.1754 39.9053 13.7276 39.353 13.7276H29.5683ZM19.7194 9.1933C20.1099 8.80277 20.7431 8.80277 21.1336 9.1933L23.9608 12.0205C24.5908 12.6505 24.1446 13.7276 23.2537 13.7276H17.5993C16.7084 13.7276 16.2622 12.6505 16.8921 12.0205L19.7194 9.1933ZM37.8878 31.5349C37.8878 32.0872 37.4401 32.5349 36.8878 32.5349H3.96513C3.41285 32.5349 2.96513 32.0872 2.96513 31.5349V17.1928C2.96513 16.6405 3.41285 16.1928 3.96513 16.1928H36.8878C37.4401 16.1928 37.8878 16.6405 37.8878 17.1928V31.5349Z"
          fill="#000000"
        />
      </g>
      <defs>
        <clipPath id="clip0_5756_34827">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SoldOutIcon;
